import './App.css';

import Navbar from './pages/Navbar';
import Sidebar from './pages/Sidebar';
import Intro from './pages/Intro';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Footer from './pages/Footer';

function App() {
  return (<div className="text-five bg-two text-lg scroll-smooth">
    <Navbar />
    <Sidebar />
    <div className="px-5 lg:px-36">
      <Intro />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </div>
  </div>
  );
}

export default App;